import type {
  BodyUploadPortfolio,
  BodyUploadPortfolioWithFundHoldings,
} from '../../generated/facts'
import { formatDateForBackend } from '../datetime'

export type CreatePortfolio = {
  name: string
  type: 'benchmark' | 'fund' | 'private'
  localCurrencyUnit: string
  localCurrencyValue: number
  valuationDate: Date
  file: File
}

export const formatCreatePortfolioRequest = (
  portfolio: CreatePortfolio,
): BodyUploadPortfolio | BodyUploadPortfolioWithFundHoldings => ({
  portfolio_name: portfolio.name,
  total_value: portfolio.localCurrencyValue,
  valuation_date: formatDateForBackend(portfolio.valuationDate),
  lcu: portfolio.localCurrencyUnit,
  portfolio_type: portfolio.type,
  identifier_col: 'ISIN',
  weight_col: 'Weight',
  name_col: 'Name',
  portfolio_file: portfolio.file,
})
